import styles from './CriterionTag.module.css';

interface CriterionTagProps {
  /** Native audit code, e.g. "NAV-03". */
  code?: string;
  /** Localized category label, surfaced as a tooltip. */
  categoryLabel?: string;
}

/**
 * Presentational mono chip for a native Audit Criteria code (e.g. NAV-03).
 * Renders nothing when the finding could not be resolved to a criterion,
 * so it degrades gracefully on accessibility/unmapped findings.
 */
export function CriterionTag({ code, categoryLabel }: CriterionTagProps) {
  if (!code) return null;
  return (
    <span className={styles.tag} title={categoryLabel}>
      {code}
    </span>
  );
}
